import React from 'react';
import {
  DivDescribe,
  DivDescribeTitle,
  DescribeTitle,
  DivTitle,
  Title,
} from './styles';

export interface Props {
  title: string;
  describeTitle: string | JSX.Element;
}

const Describe = ({ title, describeTitle }: Props): JSX.Element => {
  return (
    <DivDescribe>
      <DivTitle>
        <Title>{title}</Title>
      </DivTitle>
      <DivDescribeTitle>
        <DescribeTitle>{describeTitle}</DescribeTitle>
      </DivDescribeTitle>
    </DivDescribe>
  );
};
export default Describe;
